<script lang="ts">
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import {getLoanRequestFormContext} from '../../context';
    import type {LoanRequestOption} from 'typings/portaro.be.types';

    export let apiPath: string;
    export let option: LoanRequestOption;
    export let isDisabled = false;
    export let dataQa: string | null = null;

    const {sendLoanRequest} = getLoanRequestFormContext();
</script>

<div class="send-loan-request-button-container">
    <KpButton buttonStyle="primary"
              {isDisabled}
              {dataQa}
              on:click={() => sendLoanRequest(apiPath, option)}>
        <slot/>
    </KpButton>
</div>

<style lang="less">
    .send-loan-request-button-container {
        align-self: center;
    }
</style>